var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!this.loading)?_c('div',{staticClass:"animated fadeIn"},[_c('tableDinamic',{attrs:{"items":this.dataLoad.items,"fields":this.dataLoad.fields,"methodsTable":this.dataLoad.methodsTable}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6fafad4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/inventory/reports/list.vue
// module id = null
// module chunks = 